module.exports = __webpack_public_path__ + "static/img/028_TO8_1488_og.143994a.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/028_TO8_1488_og.jpg
// module id = 2vS5
// module chunks = 0